import { queryClient } from '@/queryClient';
import { API_VARIACAO_CONSULTAR } from '../api/apiVariacaoConsultar';

export function invalidateVariacaoQuery(): void {
    void queryClient.invalidateQueries({ queryKey: [API_VARIACAO_CONSULTAR] });
}
